$(document).ready(function () {
    let lastScrollTop = $(window).scrollTop(); // Track the last known scroll position

    // Function to toggle dropdown visibility
    function toggleDropdown(dropdownToggle) {
        var dropdown = dropdownToggle.closest('.dropdown');
        var dropdownMenu = dropdown.find('.dropdown-menu');
        var isOpen = dropdownToggle.hasClass('show');

        // Toggle dropdown visibility
        if (isOpen) {
            dropdownToggle.removeClass('show').attr('aria-expanded', 'false');
            dropdownMenu.slideUp(300).removeClass('show').attr('aria-hidden', 'true');
        } else {
            // Close any other open dropdowns
            $('.dropdown-toggle').removeClass('show').attr('aria-expanded', 'false');
            $('.dropdown-menu').slideUp(300).removeClass('show').attr('aria-hidden', 'true');

            // Open the selected dropdown
            dropdownToggle.addClass('show').attr('aria-expanded', 'true');
            dropdownMenu.slideDown(300).addClass('show').attr('aria-hidden', 'false');
            lastScrollTop = $(window).scrollTop(); // Update the last scroll position when the dropdown is expanded
        }
    }

    // Handle dropdown toggle click
    $(document).on('click', '.dropdown-toggle', function (e) {
        e.preventDefault();
        toggleDropdown($(this));
    });

    // Close the dropdown when clicking outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.dropdown').length) {
            $('.dropdown-toggle').removeClass('show').attr('aria-expanded', 'false');
            $('.dropdown-menu').slideUp(300).removeClass('show').attr('aria-hidden', 'true');
        }
    });

    // Collapse the dropdown menu on scroll if it's expanded
    $(window).on('scroll', function () {
        var dropdownToggle = $('.dropdown-toggle');
        var dropdownMenu = $('.dropdown-menu');

        // Check if the dropdown is open and if the user has scrolled
        if (dropdownMenu.hasClass('show')) {
            let currentScrollTop = $(window).scrollTop();

            if (Math.abs(currentScrollTop - lastScrollTop) > 20) {
                dropdownToggle.removeClass('show').attr('aria-expanded', 'false');
                dropdownMenu.slideUp(300).removeClass('show').attr('aria-hidden', 'true');
            }
        }
    });

    /* Expertise sub-menu toggle */
    $(document).on('click', '.expertise-list .sub-toggle', function (e) {
        e.preventDefault();

        const subToggle = $(this);
        const listItem = subToggle.closest('li');
        const subMenu = listItem.find('.sub-menu');

        // Toggle the 'show' class on the clicked .sub-toggle and .sub-menu
        if (subToggle.hasClass('show')) {
            subToggle.removeClass('show'); 
            subMenu.slideUp(300).removeClass('show');
        } else {
            // Close any other open sub-menus
            $('.expertise-list .sub-toggle').removeClass('show');
            $('.expertise-list .sub-menu').slideUp(300).removeClass('show');

            // Add .show to the clicked .sub-toggle and .sub-menu
            subToggle.addClass('show');
            subMenu.slideDown(300).addClass('show');
        }
    });

    // Close all sub-menus when clicking outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.expertise-list').length) {
            $('.expertise-list .sub-toggle').removeClass('show');
            $('.expertise-list .sub-menu').slideUp(300).removeClass('show');
        }
    });

});

// Import GSAP core and the ScrollTrigger plugin
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Pin .dropdown-projects on scroll
window.addEventListener('load', () => {
    const dropdownProjects = document.querySelector('.dropdown-projects');
    const projectList = document.querySelector('.has-filters');

    if (dropdownProjects && projectList) {
        let placeholder;

        function calculateEndPosition() {
            const projectListHeight = projectList.offsetHeight;
            const endOffset = projectListHeight * 0.1;
            return `bottom-=${endOffset}px top`;
        }

        function getTopOffset() {
            return window.innerWidth < 768 ? '50px' : '100px';
        }

        function updateDimensions() {
            const initialLeft = dropdownProjects.getBoundingClientRect().left + 'px';
            const initialWidth = dropdownProjects.offsetWidth + 'px';
            const elementHeight = dropdownProjects.offsetHeight + 'px';

            if (placeholder) {
                placeholder.style.height = elementHeight;
            } else {
                placeholder = document.createElement('div');
                placeholder.style.height = elementHeight;
                placeholder.style.visibility = 'hidden';
            }

            return { initialLeft, initialWidth, elementHeight };
        }

        let dimensions = updateDimensions();

        const scrollTriggerInstance = ScrollTrigger.create({
            trigger: dropdownProjects,
            start: () => `top-=${getTopOffset()} top`,
            endTrigger: projectList,
            end: () => calculateEndPosition(),
            scrub: true,
            onUpdate: (self) => {
                if (self.progress > 0) {
                    if (!dropdownProjects.parentNode.contains(placeholder)) {
                        dropdownProjects.parentNode.insertBefore(placeholder, dropdownProjects);
                    }

                    dropdownProjects.style.position = 'fixed';
                    dropdownProjects.style.top = getTopOffset();
                    dropdownProjects.style.left = dimensions.initialLeft;
                    dropdownProjects.style.width = dimensions.initialWidth;
                } else {
                    if (dropdownProjects.parentNode.contains(placeholder)) {
                        dropdownProjects.parentNode.removeChild(placeholder);
                    }

                    dropdownProjects.style.position = 'relative';
                    dropdownProjects.style.top = '';
                    dropdownProjects.style.left = '';
                    dropdownProjects.style.width = '';
                }
            },
            onEnter: () => {
                dropdownProjects.style.position = 'fixed';
                dropdownProjects.style.top = getTopOffset();
                dropdownProjects.style.left = dimensions.initialLeft;
                dropdownProjects.style.width = dimensions.initialWidth;

                if (!dropdownProjects.parentNode.contains(placeholder)) {
                    dropdownProjects.parentNode.insertBefore(placeholder, dropdownProjects);
                }
            },
            onLeaveBack: () => {
                dropdownProjects.style.position = 'relative';
                dropdownProjects.style.top = ''; 
                dropdownProjects.style.left = ''; 
                dropdownProjects.style.width = '';

                if (dropdownProjects.parentNode.contains(placeholder)) {
                    dropdownProjects.parentNode.removeChild(placeholder);
                }
            }
        });

        ScrollTrigger.refresh();

        window.addEventListener('resize', () => {
            dimensions = updateDimensions();
            scrollTriggerInstance.refresh();
        });
    }
});
